import { call, put, select } from 'redux-saga/effects'
import api from '../../../../../services/api'
import * as Actions from './actions'

export function* searchCaixaRequest( {payload: caixaReimpressao}) {
    try {
        
        let fields = {
            caixa_numero : caixaReimpressao,
        }
        
        let client = yield call(api, 'protocolo');
        let response = yield call(client.post, `consulta/exec/caixa_pesquisar`, { filter: fields});
    
        yield put(Actions.searchCaixaSuccess(response.data));                                           
    } catch (error) {
        yield put(Actions.requestFailure());
    }
}                       

export function* sequencialOriginalRequest({payload: {nomeAplicacao}}) {
    
    try {

        const tipo = "caixaoriginal";

        let client = yield call(api, 'protocolo');
        let response = yield call(client.post, `sequencial/${tipo}`);

        let result = {
            caixa: response.data,
            tipo: tipo,
            nomeAplicacao
        }

        yield put(Actions.sequencialSuccess(result));
    } catch (error) {
        yield put(Actions.requestFailure());
    }
}

export function* sequencialCopiaRequest({payload: {nomeAplicacao}}) {

    try {

        const tipo = "caixacopia";

        let client = yield call(api, 'protocolo');
        let response = yield call(client.post, `sequencial/${tipo}`);

        let result = {
            caixa: response.data,
            tipo: tipo,
            nomeAplicacao
        }

        yield put(Actions.sequencialSuccess(result));
    } catch (error) {
        yield put(Actions.requestFailure());
    }
}

export function* insertRequest( { payload } ) {
    try {

        let client = yield call(api, 'protocolo');
        let response = []

        for( let x = 0; x < payload.length; x++) {
            let response_caixa = yield call(client.post, `/caixa/cadastrar`, payload[x]);
            response.push(response_caixa.data)        
        }

        yield put(Actions.insertSuccess(response.data));
    } catch (error) {
        yield put(Actions.requestFailure());
    }
}

export function* getTipo(value) {
    try {
        yield put(Actions.setTipo(value));
    } catch (error) {
    }
}


export function* getCapas() {
    try {
        let value = yield select(state => state.cadastrarCaixaReducer.tipo);

        yield put(Actions.setCapas(value));
    } catch (error) {
    }
}

export function* printCapa() {
    try {
        let id = yield select(state => state.cadastrarCaixaReducer.id);

        let client = yield call(api, 'protocolo');
        let response = yield call(client.get, `print-capa/${id}`);

        yield put(Actions.getPrinted(response.data));
    } catch (error) {
    }
}